// "My AI Agents Run in Parallel, Not in Sequence" — mission ready-set dispatch.
// Built behind a DEFAULT-OFF flag (MISSIONS_PARALLEL_STEPS). The serial path is
// the default; this short explains how the orchestrator fans out WHEN enabled.
// Grounded in EAKC-MVP src/lib/missions/orchestrator/. ~135s @ 30fps.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30; contiguous.
// duration ≈ round((lastCaption.fromSec + 6) * 30) so the last line holds ~6s.
export const SCENE = {
  hook: { start: 0, duration: 330 }, //       0:00–0:11  serial = slowest-path sum
  problem: { start: 330, duration: 540 }, //  0:11–0:29  one ready step per tick
  intuition: { start: 870, duration: 360 }, // 0:29–0:41  a mission is a DAG
  dag: { start: 1230, duration: 540 }, //      0:41–0:59  ready-set = deps met
  code: { start: 1770, duration: 690 }, //     0:59–1:22  readySteps + cap truncate
  dispatch: { start: 2460, duration: 510 }, // 1:22–1:39  Promise.allSettled fan-out
  honesty: { start: 2970, duration: 540 }, //  1:39–1:57  DEFAULT-OFF · three gates
  outro: { start: 3510, duration: 360 }, //    1:57–2:09
} as const;

export const TOTAL_DURATION = 3870; // 129s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
